export default __webpack_public_path__ + "static/imgWarranty-8f5100376e8410cf19325acca650d2ff.webp";